import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Plus } from "lucide-react";
import { useAuth } from "@/lib/auth";
import { useFetch } from "@/lib/hooks";
import { can, fmtDate, km } from "@/lib/format";
import { Empty, Loading, PageHeader, Panel, Table, cellCls, rowCls } from "@/components/common";
import { ClientDialog } from "@/components/forms";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";

export default function Clients() {
  const { user } = useAuth();
  const nav = useNavigate();
  const [q, setQ] = useState("");
  const [open, setOpen] = useState(false);
  const clients = useFetch<any[]>(`/clients?q=${encodeURIComponent(q)}`);
  const vehicles = useFetch<any[]>(`/vehicles?q=${encodeURIComponent(q)}`);
  return (
    <div>
      <PageHeader eyebrow="Fichier" title="Clients & véhicules"
        actions={can(user?.role, "clients_write") && <Button className="h-11" onClick={() => setOpen(true)} data-testid="new-client-btn"><Plus className="mr-2 h-4 w-4" />Nouveau client</Button>} />
      <Input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Filtrer : nom, téléphone, immatriculation, VIN…" className="mb-6 h-11 max-w-md" data-testid="clients-filter-input" />
      <Tabs defaultValue="clients">
        <TabsList><TabsTrigger value="clients" data-testid="tab-clients">Clients</TabsTrigger><TabsTrigger value="vehicles" data-testid="tab-vehicles">Véhicules</TabsTrigger></TabsList>
        <TabsContent value="clients">
          <Panel>
            {clients.loading ? <Loading /> : !clients.data?.length ? <Empty text="Aucun client" /> : (
              <Table head={["Nom", "Téléphone", "Type", "Véhicules", "Créé le"]} testId="clients-table">
                {clients.data.map((c) => (
                  <tr key={c.id} className={rowCls} onClick={() => nav(`/clients/${c.id}`)} data-testid={`client-row-${c.id}`}>
                    <td className={`${cellCls} font-semibold`}>{c.name}</td>
                    <td className={`${cellCls} font-mono-data`}>{c.phone}</td>
                    <td className={`${cellCls} text-muted-foreground`}>{c.kind}</td>
                    <td className={cellCls}>{c.vehicle_count}</td>
                    <td className={`${cellCls} text-muted-foreground`}>{fmtDate(c.created_at, false)}</td>
                  </tr>
                ))}
              </Table>
            )}
          </Panel>
        </TabsContent>
        <TabsContent value="vehicles">
          <Panel>
            {vehicles.loading ? <Loading /> : !vehicles.data?.length ? <Empty text="Aucun véhicule" /> : (
              <Table head={["Immatriculation", "Véhicule", "VIN", "Client", "Kilométrage"]} testId="vehicles-table">
                {vehicles.data.map((v) => (
                  <tr key={v.id} className={rowCls} onClick={() => nav(`/vehicules/${v.id}`)} data-testid={`vehicle-row-${v.id}`}>
                    <td className={`${cellCls} font-mono-data font-semibold`}>{v.plate}</td>
                    <td className={cellCls}>{v.brand} {v.model} {v.year || ""}</td>
                    <td className={`${cellCls} font-mono-data text-xs text-muted-foreground`}>{v.vin || "—"}</td>
                    <td className={cellCls}>{v.client_name}</td>
                    <td className={`${cellCls} font-mono-data`}>{km(v.mileage)}</td>
                  </tr>
                ))}
              </Table>
            )}
          </Panel>
        </TabsContent>
      </Tabs>
      <ClientDialog open={open} onOpenChange={setOpen} onSaved={(c) => nav(`/clients/${c.id}`)} />
    </div>
  );
}
